"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_path = __toESM(require("path"), 1);
var import_core = require("@babel/core");
var import_vitest = require("vitest");
var import_index = __toESM(require("./index"), 1);
var projectRoot = import_path.default.resolve(__dirname, "../../");
(0, import_vitest.describe)("one/babel-preset integration", function() {
  var presetWithOpts = [
    import_index.default,
    {
      projectRoot,
      includeExpoPreset: false
    }
  ];
  (0, import_vitest.it)("runs against a route file without throwing", function() {
    var code = `
      import { useLoader } from 'one'
      export default function Page() {
        return null
      }
    `;
    var result = (0, import_core.transformSync)(code, {
      filename: import_path.default.join(projectRoot, "app/index.tsx"),
      cwd: projectRoot,
      presets: [
        presetWithOpts
      ],
      parserOpts: {
        sourceType: "module",
        plugins: [
          "jsx"
        ]
      }
    });
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).toBeTruthy();
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).toContain("useLoader");
  });
  (0, import_vitest.it)("substitutes ONE_ROUTER_* process.env placeholders in metro-entry", function() {
    var code = `
      const ctx = require.context(
        process.env.ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY,
        true,
        process.env.ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING
      )
      const folder = process.env.ONE_ROUTER_ROOT_FOLDER_NAME
      module.exports = { ctx, folder }
    `;
    var result = (0, import_core.transformSync)(code, {
      filename: import_path.default.join(projectRoot, "metro-entry-ctx.js"),
      cwd: projectRoot,
      presets: [
        presetWithOpts
      ],
      parserOpts: {
        sourceType: "module"
      }
    });
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).toBeTruthy();
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).not.toContain("process.env.ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY");
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).not.toContain("process.env.ONE_ROUTER_ROOT_FOLDER_NAME");
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).not.toContain("process.env.ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING");
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).toContain('"app"');
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).toMatch(/\/\^.*\.tsx\?\$\//);
  });
  (0, import_vitest.it)("keeps client code intact in non-route files", function() {
    var code = `
      const x = 1
      export default x
    `;
    var result = (0, import_core.transformSync)(code, {
      filename: import_path.default.join(projectRoot, "src/utils/x.ts"),
      cwd: projectRoot,
      presets: [
        presetWithOpts
      ],
      parserOpts: {
        sourceType: "module"
      }
    });
    (0, import_vitest.expect)(result === null || result === void 0 ? void 0 : result.code).toContain("const x = 1");
  });
});
//# sourceMappingURL=integration.test.js.map
